<template>
    <b-card
        class="detail-card mb-0"
        header-class="rainValueGather10-card-bg"
        header-text-variant="white"
    >
        <template #header>
            <h4 class="font-weight-bold">
                {{ `${point.name}` }}
            </h4>
            <div>
                {{ `(${point.lat}, ${point.long})` }}
            </div>
        </template>
        <div style="display: flex; justify-content: space-between;">
            <DatePicker
                v-model="range"
                range
                lang="vi"
                format="DD/MM/YYYY"
                name="time"
                :shortcuts="shortcuts"
            ></DatePicker>
            <v-select
                style="width: 240px;"
                v-model="type"
                class="ml-2"
                :options="typeOptions"
                :clearable="false"
                :filterable="false"
                :searchable="false"
            ></v-select>
        </div>
        <b-overlay
            :show="isLoading"
            spinner-variant="primary"
            variant="light"
            opacity="0.5"
            blur="1px"
            rounded="sm"
        >
            <b-row class="mt-2">
                <b-col cols="12" md="6" v-for="(item, index) in listMap" :key="item.name">
                    <BarChartStatistic
                        v-if="point.chartType === 'bar'"
                        :series="listStatistic[index]"
                        :title="item.name"
                        :unit="unit"
                        :type="item.value"
                    />
                    <LineChartStatistic
                        v-if="point.chartType === 'line'"
                        :series="listStatistic[index]"
                        :title="item.name"
                        :unit="unit"
                        :type="item.value"
                    />
                </b-col>
            </b-row>
        </b-overlay>
    </b-card>
</template>

<script>
import { mapActions } from 'vuex';
import DatePicker from 'vue2-datepicker';
import BarChartStatistic from '@/components/BarChartStatistic';
import LineChartStatistic from '@/components/LineChartStatistic';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/vi';
import { getRange } from '../utils/datetime';

export default {
    components: {
        DatePicker,
        BarChartStatistic,
        LineChartStatistic
    },
    async mounted() {
        await this.$nextTick();
        this.typeOptions = await this.getDataType();
        if (this.typeOptions.length === 0) return;
        this.type = this.typeOptions[0];
        this.range = getRange(5 * 365);
        this.getData();
    },
    props: {
        point: {
            type: Object,
            required: true
        }
    },
    data: function() {
        return {
            shortcuts: [
                {
                    text: '1 tháng qua',
                    onClick() {
                        return getRange(31);
                    }
                },
                {
                    text: '3 tháng qua',
                    onClick() {
                        return getRange(92);
                    }
                },
                {
                    text: '6 tháng qua',
                    onClick() {
                        return getRange(183);
                    }
                },
                {
                    text: '1 năm qua',
                    onClick() {
                        return getRange(365);
                    }
                },
                {
                    text: '2 năm qua',
                    onClick() {
                        return getRange(730);
                    }
                },
                {
                    text: '3 năm qua',
                    onClick() {
                        return getRange(1095);
                    }
                },
                {
                    text: '5 năm qua',
                    onClick() {
                        return getRange(1825);
                    }
                }
            ],
            range: [],
            unit: '',
            typeOptions: [],
            type: null,
            isLoading: false,
            listMap: [
                {
                    name: 'Trung bình theo giờ',
                    value: 'byHour'
                },
                {
                    name: 'Trung bình theo ngày trong tuần',
                    value: 'byDay'
                },
                {
                    name: 'Trung bình theo ngày trong tháng',
                    value: 'byDate'
                },
                {
                    name: 'Theo thời gian',
                    value: 'flex'
                }
            ],
            listStatistic: [[], [], [], []]
        };
    },
    watch: {
        range() {
            this.getData();
        },
        type(value) {
            this.getData();
        }
    },
    methods: {
        ...mapActions({
            getStatisticByHour: 'statistic/byHour',
            getStatisticByDay: 'statistic/byDay',
            getStatisticByDate: 'statistic/byDate',
            getStatisticFlex: 'statistic/flex',
            getDataType: 'data/getDataType'
        }),
        async getData() {
            this.isLoading = true;
            try {
                const params = { pointId: this.point.id, type: this.type };
                if (this.range.length === 2) {
                    params.from = this.range[0];
                    params.to = this.range[1];
                }
                const list = await Promise.all([
                    this.getStatisticByHour(params),
                    this.getStatisticByDay(params),
                    this.getStatisticByDate(params),
                    this.getStatisticFlex(params)
                ]);
                for (let i = 0; i < this.listMap.length; i++) {
                    this.listStatistic[i] = [{ name: this.point.name, data: list[i] }];
                }
            } catch (error) {}
            this.isLoading = false;
        }
    }
};
</script>
<style>
.mx-datepicker-sidebar {
    width: 120px;
}
.v-select .vs__selected-options {
    flex-wrap: nowrap;
    white-space: nowrap;
    overflow: hidden;
}
</style>
